import { TopShopTooltipContents } from "@faire/deprecated-retailer-visitor-shared/components/TopShop/TopShopTooltipContents";
import { Core } from "@faire/design-tokens";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Badge } from "@faire/web/slate/deprecated/Badge";
import { getSpacing } from "@faire/web/slate/spacing";
import { Tooltip } from "@faire/web/slate/Tooltip";
import { PortalTooltip } from "@faire/web/slate/Tooltip/PortalTooltip";
import { TypographyStyles } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import React from "react";
import styled from "styled-components";

interface IProps {
  content?: string;
  className?: string;
}

export const TopShopTileBadge: React.FC<IProps> = (props) => {
  const { strictLocalize } = useStrictLocalization();

  return (
    <MaybePortalTooltip
      placement="bottom"
      className={props.className}
      tooltipZIndex={1005}
      tooltip={
        <Tooltip width={308} position="bottom" isOpen icon={<div />}>
          <TopShopTooltipContents />
        </Tooltip>
      }
    >
      <StyledBadge
        content={
          props.content ??
          strictLocalize({ id: "RhE5gS", defaultMessage: "Top Shop" })
        }
        backgroundColor={Core.surface.inverse}
      />
    </MaybePortalTooltip>
  );
};

const StyledBadge = styled(Badge)`
  && {
    ${TypographyStyles({ variant: "labelSansRegular" })};
    font-weight: 500;
    padding: ${getSpacing(3, 7)};
    cursor: pointer;
  }
`;

const MaybePortalTooltip = (
  props: React.ComponentProps<typeof PortalTooltip>
) => {
  const { isTabletAndBelow } = useViewport();
  if (isTabletAndBelow) {
    return <div className={props.className}>{props.children}</div>;
  }
  return <PortalTooltip {...props} />;
};
